export enum ModoAoVencerAutomacaoOrdemServicoEnum {
  ExecutarAutomaticamente = 1,
  ApenasNotificar = 2,
}
